var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "TabsUnderline",
    {
      attrs: {
        options: _vm.tabs,
        selectedIndex: _vm.tabIndex,
        routes: _vm.routeNames,
        navClass: _vm.navClass,
        listClass: _vm.listClass,
      },
      on: { select: (index) => _vm.setRoute(index) },
      scopedSlots: _vm._u(
        [
          _vm._l(_vm.routeNames, function (route) {
            return {
              key: route,
              fn: function () {
                return [_vm._t(route)]
              },
              proxy: true,
            }
          }),
        ],
        null,
        true
      ),
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }